import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useUser } from "../../../../hooks/use-user";
import axios from "../../../../axios";
import { toast } from "react-toastify";
import {
  CheckCircle2,
  AlertCircle,
  Gem,
  Zap,
  Star,
  ShieldCheck,
  ChevronRight,
  ArrowRight,
  CirclePlay,
  Play,
  CirclePlayIcon,
} from "lucide-react";
import { motion } from "framer-motion";
import CourseCard from "./CourseCard";
import { getAppControls } from "../../../../services/configService";

function LearnPlan() {
  const { data: user } = useUser();
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showCheckOutPage, setShowCheckOutPage] = useState(true);
  const [gatewayVisibilityWeb, setgatewayVisibilityWeb] = useState(true);
  const [pageLoading, setPageLoading] = useState(true);
  const [buyCourseVideoUrl, setBuyCourseVideoUrl] = useState("");

  useEffect(() => {
    async function fetchData() {
      setPageLoading(true);
      try {
        const meResponse = await axios.get("me");
        const freshUser = meResponse?.data?.result || user || {};
        const selectedExam =
          freshUser?.selectedExam?._id ||
          freshUser?.selectedExam ||
          localStorage.getItem("examId");

        const response = await axios.get(
          selectedExam ? `getAllCourses?examId=${selectedExam}` : "getAllCourses"
        );
        if (response?.data) {
          setData(response?.data?.result);
          localStorage.setItem("plans", JSON.stringify(response?.data?.result));
        }
      } catch (error) {
        console.error("Error fetching courses:", error);
      } finally {
        setPageLoading(false);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    async function gatewayVisibility() {
      try {
        const response = await axios.get("getGetwaySetting");
        if (
          Array.isArray(response.data.result) &&
          response.data.result.length > 0
        ) {
          const latest = response.data.result[response.data.result.length - 1];
          setShowCheckOutPage(latest.showcheckOutPageInWeb);
          setgatewayVisibilityWeb(latest.gatewayVisibilityWeb);
        }
      } catch (error) {
        console.error("Error fetching gateway settings:", error);
      }
    }
    gatewayVisibility();
  }, []);

  useEffect(() => {
    async function fetchAppControls() {
      try {
        const response = await getAppControls();
        const controls = response?.result || response?.data || response || {};
        setBuyCourseVideoUrl(
          controls?.tutorialBuyCourse ||
            controls?.howToBuyMockTest ||
            controls?.howAdhyayiWorks ||
            "",
        );
      } catch (error) {
        console.error("Error fetching app controls:", error);
      }
    }

    fetchAppControls();
  }, []);

  const handlePayment = (courseId) => {
    setLoading(true);
    axios
      .post("createOrder", { courseId })
      .then((response) => {
        if (response?.data) {
          window.location.href = response.data?.result?.upiLink;
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error("Payment initiation failed");
      });
  };

  const handlePayNow = (courseId) => {
    if (!gatewayVisibilityWeb) {
      alert("Due to some technical issue payment is not being processed");
      return;
    }
    handlePayment(courseId);
  };

  const handleWatchVideo = () => {
    if (!buyCourseVideoUrl) {
      toast.error("Video link is not available right now");
      return;
    }

    window.location.href = buyCourseVideoUrl;
  };

  if (pageLoading) {
    return (
      <div className="min-h-screen bg-[#2A1B3D] flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-4 border-purple-500 border-t-transparent rounded-full animate-spin"></div>
          <p className="text-gray-400 text-sm">Loading plans...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-purple-50 pt-6 lg:pt-16 pb-20 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-full h-[500px] bg-gradient-to-b from-purple-900/20 to-transparent pointer-events-none"></div>
      <div className="absolute top-[-100px] right-[-100px] w-96 h-96 bg-purple-600/10 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-0 left-[-100px] w-80 h-80 bg-indigo-600/10 rounded-full blur-3xl pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        {/* <div className="text-center max-w-3xl mx-auto mb-16">
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-purple-500/10 text-purple-300 text-sm font-medium mb-6 border border-purple-500/20">
              <Gem size={16} className="text-purple-400" />
              Premium Learning Experience
            </span>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
              Choose the Perfect Plan for <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400">
                Your Success
              </span>
            </h1>
            <p className="text-lg text-gray-400 leading-relaxed">
              Unlock unlimited access to premium courses, expert mentorship, and
              real-world projects. Start your journey today.
            </p>
          </motion.div>
        </div> */}

        {/* Plans Grid */}
        {/* <div className="flex flex-col gap-6 px-4 pb-24">
  {data.map((plan, index) => (
    <CourseCard key={plan._id} plan={plan} index={index} />
  ))}
</div> */}
{/* video card */}
 <div className="px-1 pb-4 sm:px-5">
        <div className="flex items-center justify-between gap-3 rounded-[1.1rem] bg-[#552062] px-4 py-3 text-white shadow-sm">
          <div className="min-w-0">
            <h3 className="text-left font-bold leading-tight sm:text-xl">
              How to buy Mock Test
            </h3>
            <p className="mt-1 text-left text-[10px] font-medium leading-5 text-white/80 sm:text-[10px]">
              Access structured lessons, advanced quizzes and exclusive contests from one place.
            </p>
          </div>
          <button
            type="button"
            onClick={handleWatchVideo}
            className="inline-flex h-10 shrink-0 items-center justify-center gap-2 rounded-full bg-white px-3 text-[11px] font-bold text-[#32193C] shadow-sm sm:px-4 sm:text-sm"
          >
            Watch Video
            <CirclePlayIcon className="h-4 w-4" />
          </button>
        </div>
      </div>
{/* 4 cards in desktop view */}
<div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-4">
  {data?.map((plan, index) => (
    <CourseCard
      key={plan._id}
      plan={plan}
      index={index}
    />
  ))}
</div>

        {/* Footer Note */}
        {/* <div className="mt-16 text-center">
          <p className="text-gray-500 text-sm flex items-center justify-center gap-2">
            <AlertCircle size={14} />
            Need help choosing?{" "}
            <a
              href="/contact"
              className="text-purple-400 hover:text-purple-300 transition-colors"
            >
              Contact Support
            </a>
          </p>
        </div> */}
      </div>
    </div>
  );
}

export default LearnPlan;
